import React from 'react';

import { joinClassNames } from '../../../util/util';

interface SVGWrapperProps {
	settings?: any;
	id?: string;
	noMouseEvent?: boolean;
	isMobile?: boolean;
	className?: string;
	showVerticalViewBox?: boolean;
	videoRatio?: number;
	style?: any;
	children?: React.ReactNode;
	tabIndex?: number;
	onMouseLeave?: (_event: React.MouseEvent) => void;
	onMouseMove?: (_event: React.MouseEvent) => void;
	onTouchStart?: (_event: React.TouchEvent) => void;
	onTouchEnd?: (_event: React.TouchEvent) => void;
	onTouchMove?: (_event: React.TouchEvent) => void;
	onKeyDown?: (_event: React.KeyboardEvent) => void;
	onKeyUp?: (_event: React.KeyboardEvent) => void;
	htmlRef?: React.Ref<SVGSVGElement>;
	isIFrameWidgetAvailable?: boolean;
}

const baseClassName = 'interactOverlayContainer';

const SVGWrapper = ({
	noMouseEvent = true,
	className,
	id,
	showVerticalViewBox,
	videoRatio,
	style,
	children,
	isMobile,
	tabIndex,
	onMouseLeave,
	onMouseMove,
	onTouchStart,
	onTouchEnd,
	onTouchMove,
	onKeyDown,
	onKeyUp,
	htmlRef,
	isIFrameWidgetAvailable,
}: SVGWrapperProps) => {
	return (
		// The wrapper is a size container so the SVG box itself can be sized to the video ratio and centered
		<div className={`${baseClassName}Wrapper`}>
			<svg
				ref={htmlRef}
				className={joinClassNames([
					'mainSVG',
					baseClassName,
					showVerticalViewBox ? `${baseClassName}--vertical` : '',
					// The iframe widget sits underneath the SVG (see widgets/Iframe.tsx), so let touches through.
					noMouseEvent || isIFrameWidgetAvailable ? `${baseClassName}--noMouseEvent` : '',
					className,
				])}
				id={id ?? 'mainSVG'}
				viewBox={showVerticalViewBox ? '547 0 506 900' : '0 0 1600 900'}
				// The box has the video's ratio, so stretch the viewBox onto it: x 0-1600 / y 0-900 is always the whole video
				preserveAspectRatio="none"
				style={videoRatio ? { '--overlay-ratio': videoRatio, ...style } : style}
				onMouseLeave={isMobile ? undefined : onMouseLeave}
				onMouseMove={isMobile ? undefined : onMouseMove}
				onTouchStart={onTouchStart}
				onTouchMove={onTouchMove}
				onTouchEnd={onTouchEnd}
				tabIndex={tabIndex}
				onKeyDown={onKeyDown}
				onKeyUp={onKeyUp}
			>
				{children}
			</svg>
		</div>
	);
};

export default SVGWrapper;
